import { TZDate } from '@date-fns/tz'
import { getTodayInDefaultTimeZone, startOfDayInDefaultTimeZone } from '@utils/helpers'
import { formatIsoDate } from '@utils/utils-format'
import { isValid } from 'date-fns'
import type { inferParserType } from 'nuqs/server'
import { createParser } from 'nuqs/server'
import { DEFAULT_TIME_ZONE } from '@/lib/time-zone'

const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/

export function rejectPastDate<T extends Date | null | undefined>(
  date: T,
  today: Date = getTodayInDefaultTimeZone()
): T | null {
  if (!date || !isValid(date)) return null

  const day = startOfDayInDefaultTimeZone(date)
  const todayDay = startOfDayInDefaultTimeZone(today)

  return day < todayDay ? null : date
}

const parseAsIsoDate = createParser({
  serialize: (value: Date | null | undefined): string => {
    if (!value) return ''
    return formatIsoDate(value)
  },
  parse: (value: string | (string | null)[] | null | undefined): Date | null => {
    if (!value || typeof value !== 'string' || !ISO_DATE_PATTERN.test(value)) return null

    const parsed = new TZDate(value, DEFAULT_TIME_ZONE)

    if (!isValid(parsed) || formatIsoDate(parsed) !== value) return null

    return parsed
  },
})

export const dateParser = {
  from: parseAsIsoDate,
  to: parseAsIsoDate,
}

export type DateParams = inferParserType<typeof dateParser>
